"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An abstract class that adheres to the data connector interface.
 *
 * #### Notes
 * The only abstract method in this class is the `fetch` method, which must be
 * reimplemented by all subclasses. The `remove` and `save` methods have a
 * default implementation that returns a promise that will always reject. This
 * class is a convenience superclass for connectors that only need to `fetch`.
 */
var DataConnector = /** @class */ (function () {
    function DataConnector() {
    }
    /**
     * Remove a value using the data connector.
     *
     * @param id - The identifier for the data being removed.
     *
     * @returns A promise that is rejected if remove fails and succeeds otherwise.
     *
     * #### Notes
     * This method will always reject; subclasses should reimplement it if they
     * support a back-end that can remove resources.
     */
    DataConnector.prototype.remove = function (id) {
        return Promise.reject(new Error('Removing has not been implemented.'));
    };
    /**
     * Save a value using the data connector.
     *
     * @param id - The identifier for the data being saved.
     *
     * @param value - The data being saved.
     *
     * @returns A promise that is rejected if saving fails and succeeds otherwise.
     *
     * #### Notes
     * This method will always reject; subclasses should reimplement it if they
     * support a back-end that can save resources.
     */
    DataConnector.prototype.save = function (id, value) {
        return Promise.reject(new Error('Saving has not been implemented.'));
    };
    return DataConnector;
}());
exports.DataConnector = DataConnector;
